import { FC, memo } from "react";
import { ReattemptApprovalForm } from "./ReattemptApprovalForm";
import { ConfirmationModal } from "./ConfirmationModal";
import { MODAL_TITLES, CONFIRMATION_MESSAGES } from "../Regtank.constants";

interface ApprovalRejectionSectionProps {
  showSection: boolean;
  remark: string;
  onRemarkChange: (value: string) => void;
  nameRole: string;
  onApprove: () => void;
  onReject: () => void;
  approveButtonDisabled: boolean;
  rejectButtonDisabled: boolean;
  modals: {
    openedVerificationAppr: boolean;
    closeVerificationAppr: () => void;
    openVerificationAppr: () => void;
    openedVerificationReject: boolean;
    closeVerificationReject: () => void;
    openVerificationReject: () => void;
  };
}

const ApprovalRejectionSectionComponent: FC<ApprovalRejectionSectionProps> = ({
  showSection,
  remark,
  onRemarkChange,
  nameRole,
  onApprove,
  onReject,
  approveButtonDisabled,
  rejectButtonDisabled,
  modals,
}) => {
  if (!showSection) return null;

  return (
    <>
      <ReattemptApprovalForm
        remark={remark}
        onRemarkChange={onRemarkChange}
        onApprove={modals.openVerificationAppr}
        onReject={modals.openVerificationReject}
        approveButtonDisabled={approveButtonDisabled}
        rejectButtonDisabled={rejectButtonDisabled}
      />
      <ConfirmationModal
        opened={modals.openedVerificationAppr}
        onClose={modals.closeVerificationAppr}
        title={MODAL_TITLES.confirmApproval}
        message={CONFIRMATION_MESSAGES.approve(nameRole)}
        onConfirm={onApprove}
      />
      <ConfirmationModal
        opened={modals.openedVerificationReject}
        onClose={modals.closeVerificationReject}
        title={MODAL_TITLES.confirmRejection}
        message={CONFIRMATION_MESSAGES.reject(nameRole)}
        onConfirm={onReject}
      />
    </>
  );
};

export const ApprovalRejectionSection = memo(ApprovalRejectionSectionComponent);
